module.exports = __webpack_public_path__ + "img/20191126162656427.43015104.jpg";